export default __webpack_public_path__ + "static/media/neon_milkshake@3x.c181123e.png";